import { useEffect } from 'react';

import { useWindowEvent } from '@mantine/hooks';
import { debounce } from 'radash';
import { useSnapshot } from 'valtio';

import { viewportSizeState } from 'state/dom/viewport-size';

const useViewportSize = () => {
    return useSnapshot(viewportSizeState);
};

const update = debounce({ delay: 222 }, () => {
    viewportSizeState.width = window.innerWidth;
    viewportSizeState.height = window.innerHeight;
});

const useViewportSizeSetter = () => {
    useEffect(() => {
        viewportSizeState.width = window.innerWidth;
        viewportSizeState.height = window.innerHeight;
    }, []);

    useWindowEvent('resize', update, { passive: true });
    useWindowEvent('orientationchange', update, { passive: true });
};

export { useViewportSize, useViewportSizeSetter };
